<template>
  <div :class="classes">
    <pt-page-title title="分/子公司管理" isSearch @search="search" @emptySearch="emptySearch" placeholder="请输入公司名称搜索"
      :searchKey="searchKey" @searchNo="searchNo" isParams>
      <template slot="before-left">
        <el-button type="primary" @click="createCompany">创建分/子公司</el-button>
      </template>
    </pt-page-title>
    <!-- <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter> -->
    <pt-branch-company-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" ref="table"
      :paramsData="paramsData" :class="$style['pt-branch-company-table']">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="iconfont icon-xiangqing" @click="goDetail(scope.row)"></i>
          <i class="iconfont icon-bianji" @click="goEdit(scope.row)"></i>
          <i class="iconfont icon-shanchu" @click="goDelete(scope.row)"></i>
        </template>
      </el-table-column>
    </pt-branch-company-table>
  </div>
</template>

<script>
// 组件class前缀
import {
  companyTableFilter,
  companyTableLabels
} from './branch-company'
import ptBranchCompanyTable from './pt-branch-company-table/withData'
import {
  emptyObject
} from '@/utils/lifebankUtils'
const prefixCls = 'pt-branch-company'

export default {
  name: 'pt-branch-company',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptBranchCompanyTable
  },
  props: {
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      filterLabels: companyTableFilter,
      tableLabels: companyTableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: null
    }
  },
  watch: {
    rolesList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'role') {
            item.options = val
          }
        })
      }
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = {
        searchKey: val
      }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    searchNo (val) {
      this.searchKey = val
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      console.log('this.isFromRouter', this.isFromRouter)
      this.paramsData = {
        ...this.params
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    },
    goEdit (val) {
      this.$router.push('/branch-company/branch-company-form/true/' + val.id)
    },
    goDelete (val) {
      this.$confirm('您确定删除该分/子公司吗？', '删除分/子公司', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteBranchCompany', val.id)
      })
    },
    goDetail (val) {
      this.$router.push('./branch-company-detail/' + val.id)
    },
    createCompany () {
      this.$router.push('/branch-company/branch-company-form/false/0')
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-branch-company-table {
    :global .iconfont {
      margin-right: 10px;
    }
  }

</style>
